var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3ec04189aef13f9f57bce5404222c173b7397dcd"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website-next@upflow"]={id:"3ec04189aef13f9f57bce5404222c173b7397dcd"};
      